import { AbstractModel, DateFormatConstants, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import moment from 'moment-timezone';
import { Driver } from './driver';

@inheritSerialization(AbstractModel)
export class InterestedDriver extends AbstractModel {
  @autoserialize
  rideRequestId: number;

  @autoserialize
  vehicleId: number;

  @autoserializeAs(Driver)
  driver: Driver;

  @autoserialize
  proposingNewPickupTime: boolean;

  @autoserializeAs(Date)
  proposedPickupTime: Date;

  @autoserialize
  onWavPlatform: boolean;

  @autoserialize
  deviceInstallationId: number;

  get formattedProposedPickupTime(): string {
    if (isNullOrUndefined(this.proposedPickupTime)) {
      return null;
    }
    return moment(this.proposedPickupTime).format(DateFormatConstants.TIME);
  }

  static OnSerialized(instance: InterestedDriver, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(json['proposedPickupTime'])) {
      json['proposedPickupTime'] = DateUtil.serializeInstant(instance.proposedPickupTime);
    }
  }

  static OnDeserialized(instance: InterestedDriver, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['proposedPickupTime'])) {
      instance.proposedPickupTime = DateUtil.deserializeInstant(json['proposedPickupTime']);
    }
  }
}
